import React, { Component } from 'react'; //different
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import moment from 'moment';
import { Outlet, Link } from "react-router-dom";
import Mainindex from './mainindex';
import { t } from './i18n';
class App extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            activeTab: 1,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form

            userid: null,
            point: 0,
            balance: 0,
            loginstate: null,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            username: "",
            amount: "",
            remark: "",
            mainacc: "",
            rankpic: "1.jpeg",
            pathname: "",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            name: "",
            password: "",
            left: false,
        }
    }
    logout = (e) => {

        // window.location.href = '/logout';

    }
    async componentDidMount() {
        this.setState({
            pathname: window.location.pathname.replace("/", "").trim()
        });
        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                this.setState({
                    linelink: datas[1].value,
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });
        var userAgent = navigator.userAgent.toLowerCase()

        try {
            var token = localStorage.getItem('auth_token');
            //  //////console.log(token);
            if (token != null) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                await this.rechecklogin(Username, token);
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    firstname: decoded.message.firstname,
                    lastname: decoded.message.lastname,
                    loginstate: true,
                });
            }
            else {
                this.setState({
                    loginstate: false,
                });
            }
        }
        catch (error) {
            console.log(error);
        }

    }
    openAccout(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className += " -open";
        }
    }

    cancelredeempromotion = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: t(this.lang, 'ap_cancel_promo_question'),
                showCancelButton: true,
                confirmButtonText: 'Save',
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    await instance.post("/api/v1/usercancelpromotion", {
                        User_id: Username,
                        System: Systems,
                        no: index.no,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            this.checkpro(null, 999);
                            Swal.fire(t(this.lang, 'ap_action_done'), '', 'success')
                        }
                        else {
                            Swal.fire(t(this.lang, 'ap_action_failed_wait'), '', 'error')
                        }
                    });

                }
            })
        }

    }

    openAccoutcan(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className = "x-menu-account-list-sidebar";
        }
    }

    async rechecklogin(Username, token) {

        try {
            // console.log(4);
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        rankpic: res.data.tblrank.image,
                        rankname: res.data.tblrank.name,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'ap_session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ap_ok')
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'ap_session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ap_ok')
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                //console.log(res.data)
                // console.log(res.data.message.tblpromotionredeems)
                if (res.data.type === 0) {
                    this.setState({
                        prodetail: res.data.message.tblpromotions,
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        proderedeemlist: res.data.message.tblpromotionredeems,
                    });

                }

            }
            else if (res.data.status === 201) {
                await Swal.fire({
                    title: 'error!',
                    text: t(this.lang, 'ap_promo_not_eligible'),
                    icon: 'error',
                    confirmButtonText: t(this.lang, 'ap_ok')
                })
                return false;
            }
            else if (res.data.status === 202) {
                await Swal.fire({
                    title: 'error!',
                    text: t(this.lang, 'ap_promo_pending_can_topup'),
                    icon: 'error',
                    confirmButtonText: t(this.lang, 'ap_ok')
                })
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await Swal.fire({
                    title: 'Warning!',
                    text: t(this.lang, 'ap_session_expired'),
                    icon: 'warning',
                    confirmButtonText: t(this.lang, 'ap_ok')
                })
                window.location.href = '/';
            }
        });
    }


    validateLogout = (e) => {
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //  this.rechecklogin(Username, token);
        this.setState({
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            //  console.log(5);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                    var i, tablinks;
                    tablinks = document.getElementsByClassName("-btn-balance");
                    for (i = 0; i < tablinks.length; i++) {
                        tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
                    }
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    //   console.log(res.data);
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'ap_session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ap_ok')
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                //    console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'ap_session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ap_ok')
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    render() {
        const pathname = this.state.pathname
        const { loginstate, userid, username, point, firstname, lastname, balance, proderedeemlist } = this.state
        // //////console.log(this.state);
        return (
            <>
        
                <div
                    className="x-modal modal -v2"
                    id="joinPromotionModalMobile"
                    tabIndex={-1}
                    role="dialog"
                    data-container="#joinPromotionModalMobile"
                    aria-modal="true"
                >
                    <div
                        className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-mobile -no-fixed-button -no-padding-x"
                        role="document"
                    >
                        <div className="modal-content -modal-content">
                            <button
                                type="button"
                                className="close f-1 "
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fas fa-times" />
                            </button>
                            <div className="modal-header -modal-header">
                                <div className="x-modal-mobile-header">
                                    <div className="-header-mobile-container">
                                        <h3 className="x-title-modal mx-auto text-center d-inline-block">
                                            {t(this.lang,'ap_join_promo')}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body -modal-body">
                                <div className="-outer-history-wrapper">
                                    <div className="x-bill-history-container">
                                        <div
                                            className="wg-container wg-container__wg_bill_history wg--loaded"
                                            data-widget-name="wg_bill_history"
                                            data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                                            data-widget-user-options='{"page":1}'
                                        >
                                            <div className="wg-content" style={{ display: (proderedeemlist.length === 0) ? "" : "none" }}>
                                                <div className="-no-result-wrapper mt-3">
                                                    <div className="-heading-title">
                                                        <i className="fas fa-times-circle -icon" />
                                                        <div className="-title">{t(this.lang,'ap_no_data')}</div>
                                                        <div className="-sub-title">{t(this.lang,'ap_no_history')}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="wg-content" style={{ display: (proderedeemlist.length === 0) ? "none" : "" }}>
                                                <table className="table table-borderless table-striped">
                                                    <tbody>
                                                        {proderedeemlist.map((listitem, i) => (
                                                            <tr key={i} id={i}>
                                                                <td className="-description-body-wrapper">
                                                                    <div className="-title-wrapper">
                                                                        <span className="-title">{listitem.proname}</span>
                                                                        <span style={{ display: (listitem.status === 1) ? "" : "none", margin: "5px" }}>
                                                                            <a href="#0"
                                                                                onClick={(e) => {
                                                                                    this.cancelredeempromotion(e, listitem)
                                                                                }}
                                                                                className="-link-change-password" ><u>{t(this.lang,'ap_cancel')}</u></a>
                                                                        </span>
                                                                    </div>
                                                                    <div className="-state-wrapper" style={{ display: (listitem.status === 1) ? "" : "none" }}>
                                                                        <span className="-state-text">{t(this.lang,'ap_status_label')}</span>
                                                                        <i className="fas fa-spinner fa-spin"></i>
                                                                        <span className="-state-title">{t(this.lang,'ap_status_pending')}</span>
                                                                        <span className="-state-title -short">{t(this.lang,'ap_status_pending')}</span>
                                                                    </div>
                                                                    <div className="-state-wrapper" style={{ display: (listitem.status === 4) ? "" : "none" }}>
                                                                        <span className="-state-text">{t(this.lang,'ap_status_label')}</span>
                                                                        <img
                                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                            className="-ic"
                                                                            alt=""
                                                                        />
                                                                        <span className="-state-title">{t(this.lang,'ap_status_cancel_by_player')}</span>
                                                                        <span className="-state-title -short">{t(this.lang,'ap_status_cancel_by_player_short')}</span>
                                                                    </div>
                                                                    <div className="-state-wrapper" style={{ display: (listitem.status === 3) ? "" : "none" }}>
                                                                        <span className="-state-text">{t(this.lang,'ap_status_label')}</span>
                                                                        <img
                                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                            className="-ic"
                                                                            alt=""
                                                                        />
                                                                        <span className="-state-title">{t(this.lang,'ap_status_fail_by_system')}</span>
                                                                        <span className="-state-title -short">{t(this.lang,'ap_status_fail_by_system')}</span>
                                                                    </div>
                                                                    <div className="-state-wrapper" style={{ display: (listitem.status === 2) ? "" : "none" }}>
                                                                        <span className="-state-text">{t(this.lang,'ap_status_label')}</span>
                                                                        <img
                                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                                                            className="-ic"
                                                                            alt=""
                                                                        />
                                                                        <span className="-state-title">{t(this.lang,'ap_status_success')}</span>
                                                                        <span className="-state-title -short">{t(this.lang,'ap_status_success')}</span>
                                                                    </div>
                                                                </td>
                                                                <td className="-transaction-body-wrapper">
                                                                    <div className="-amount -deposit">{ Number(listitem.credit).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} {t(this.lang,'ap_baht')}</div>
                                                                    <div className="-datetime">{moment(listitem.datecreate).format('DD/MM/YY') + " - " + moment(listitem.datecreate).format('HH:mm') + " " + t(this.lang,'mr_hr')} </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default App;
